var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 12.79 5.23 C 13.077 5.528 13.068 6.003 12.77 6.29 L 8.832 10 L 12.77 13.71 C 12.972 13.894 13.059 14.173 12.996 14.439 C 12.933 14.705 12.73 14.915 12.467 14.988 C 12.203 15.061 11.921 14.985 11.73 14.79 L 7.23 10.54 C 7.083 10.399 7 10.204 7 10 C 7 9.796 7.083 9.601 7.23 9.46 L 11.73 5.21 C 12.028 4.923 12.503 4.932 12.79 5.23 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.42d9ec834c06fe73a024e1f40cda9be1.svg";
export { ForwardRef as ReactComponent };